import React, {useMemo} from "react";
import styled from 'styled-components';
import {connect} from "react-redux";
import {quickLinkTypes} from "./quickLinkTypes";
import {BackQuickLinkWrapper, QuickLinksWrapper, NextQuickLinkWrapper} from "./styles"
import {useWindowSize} from "../Utility/hooks";

const QuickLinksContainer = styled.div`
  ${({
       specialsType,
       inputVisible
     }) => !inputVisible && specialsType !== "virtual" && specialsType !== "multibot" && specialsType !== "unitmap" &&  `padding-top: 18px;`};

  ${({specialsType}) => specialsType === "floorplan" && `padding-top: 10px;`};

  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakSmall}) {
    ${({
         specialsType,
         inputVisible
       }) => !inputVisible && specialsType !== "virtual" && specialsType !== "multibot" && specialsType !== "unitmap" && `padding-top: 24px;`};
  }
  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakLaptop}) {
    padding-bottom: 0;
  }
`;

function List({quicklinks, specials, inputVisible, rentgrata }) {

  const {width} = useWindowSize();
  const specialsType = useMemo(() => specials.type, [specials])

  if (specials && specials.type === "floorplan" && width && width >= 500) {
    return null;
  }

  const backQuickLink = quicklinks
    .filter(ql => ql.subType && ql.subType === "back")
    .map((quickLink, key) => {
      const type = quickLink.type || 'text';
      const QuickLinkType = quickLinkTypes[type];
      return (
        <QuickLinkType
          key={`quickLinks-${key}`}
          data={quickLink}
        />
      );
    });

  const nextQuicklink = quicklinks
    .filter(ql => ql.subType && ql.subType === "next")
    .map((quickLink, key) => {
      const type = quickLink.type || 'text';
      const QuickLinkType = quickLinkTypes[type];
      return (
        <QuickLinkType
          key={`quickLinks-${key}`}
          data={quickLink}
        />
      );
    });

  const quickLinksFiltered = quicklinks
    .filter(ql => {
      if (ql.value === 'Rentgrata-TalkToResidentConversation' && !rentgrata) {
        return false;
      }
      if (ql.subType) {
        return ql.subType !== "back" && ql.subType !== "next";
      }
      return ql;
    });

  const hasImageQuickLinks = quickLinksFiltered.some(ql => ql.hasOwnProperty("image"))

  return quicklinks.length > 0 && (
    (quickLinksFiltered || backQuickLink || nextQuicklink) &&
    <QuickLinksContainer className="QuickLinksContainer" specialsType={specialsType} inputVisible={inputVisible}>
      {(specials && specialsType !== "floorplan") && (
        <QuickLinksWrapper className="QuickLinksWrapper" hasImageQuickLinks={hasImageQuickLinks}>
          {
            quickLinksFiltered
              .map((quickLink, key) => {
                const type = quickLink.type || 'text';
                const QuickLinkType = quickLinkTypes[type];

                return (
                  <QuickLinkType
                    key={`quicklinks-${key}`}
                    data={quickLink}
                  />
                );
              })
          }
        </QuickLinksWrapper>
      )}
      {backQuickLink &&
      <BackQuickLinkWrapper className="BackQuickLinkWrapper">
        {backQuickLink[0]}
      </BackQuickLinkWrapper>
      }
      {nextQuicklink &&
      <NextQuickLinkWrapper className="NextQuickLinkWrapper">
        {nextQuicklink[0]}
      </NextQuickLinkWrapper>
      }
    </QuickLinksContainer>
  );
}

const mapStateToProps = (state) => ({
  quicklinks: state.chat.quicklinks,
  specials: state.chat.specials,
  inputVisible: state.chat.input.visible,
  rentgrata: state.settings.rentgrata,
  selectedQuicklinks: state.chat.selectedQuicklinks
});

export default connect(mapStateToProps)(List);
